import React from "react";
import "./PDFViewer.styles.scss";
import Error from "@mui/icons-material/Error";
import { Button, Tooltip, Typography } from "@mui/material";

interface Props {
  loading: boolean;
  error: string | null;
  filename: string;
  numPages: number;
  pageNumber: number;
  zoom: number;
  setZoom: (setter: (zoom: number) => number) => void;
  setPageNumber: (page: number) => void;
}
const PDFTopBar = (props: Props) => {
  return (
    <div className="document-action-bar">
      <Typography variant="subtitle1">{props.filename.substring(0, 30)}</Typography>
      {props.error && (
        <Tooltip title={props.error}>
          <Error color="error" />
        </Tooltip>
      )}
      <div className="page-zoom">
        <span className="page-zoom__btn" onClick={() => props.setZoom((zoom) => Math.min(zoom - 0.2, 2.4))}>
          -
        </span>
        <div className="page-zoom__value">{Math.floor(props.zoom * 100)}%</div>
        <span className="page-zoom__btn" onClick={() => props.setZoom((zoom) => Math.min(zoom + 0.2, 2.4))}>
          +
        </span>
      </div>
      <div className="page-navigation">
        {props.pageNumber > 1 && (
          <Button
            className="page-navigation__btn page-navigation__btn--left small-btn"
            variant="contained"
            color="primary"
            onClick={() => props.setPageNumber(props.pageNumber - 1)}
          >
            {"<"}
          </Button>
        )}
        <Typography variant="subtitle1">
          Page {props.pageNumber} of {props.numPages}
        </Typography>
        {props.pageNumber < props.numPages && (
          <Button
            className="page-navigation__btn page-navigation__btn--right small-btn"
            variant="contained"
            color="primary"
            onClick={() => props.setPageNumber(props.pageNumber + 1)}
          >
            {">"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PDFTopBar;
